import { NgModule } from '@angular/core';

import { MzSpinnerComponent } from './spinner.component';

@NgModule({
  declarations: [MzSpinnerComponent],
  exports: [MzSpinnerComponent],
})
export class MzSpinnerModule { }
